import { useSyncExternalStore } from "react";
import { SettingRow, Switch } from "../../camera/SettingsParts.js";
import { useVehicleT } from "../i18n.js";
import { vehicleAudio } from "./audio.js";

/** The vehicle sound settings (live, persisted). */
export function useVehicleSound(): typeof vehicleAudio.settings {
  return useSyncExternalStore(
    (l) => vehicleAudio.subscribe(l),
    () => vehicleAudio.settings,
  );
}

/** Vehicle sounds on/off and their volume, for the settings sheet's Sound section. */
export function VehicleSoundSettings() {
  const t = useVehicleT();
  const s = useVehicleSound();
  return (
    <>
      <Switch
        label={t("soundOn")}
        checked={s.enabled}
        testId="vehicle-sound-toggle"
        onChange={(on) => vehicleAudio.set({ enabled: on })}
      />
      <SettingRow
        label={t("volume")}
        value={`${Math.round(s.volume * 100)}%`}
        htmlFor="vehicle-volume"
        stacked
      >
        <input
          id="vehicle-volume"
          type="range"
          min={0}
          max={100}
          step={5}
          value={Math.round(s.volume * 100)}
          disabled={!s.enabled}
          data-testid="vehicle-volume"
          onChange={(e) => vehicleAudio.set({ volume: Number(e.target.value) / 100 })}
        />
      </SettingRow>
    </>
  );
}
